import * as apiPost from 'api/orderGuide/PostErpOrderGuideCreateV1';
import * as apiPostSearch from 'api/orderGuide/PostErpOrderGuideV1';
import * as apiPut from 'api/orderGuide/PutErpOrderGuideUpdateV1';
import { ErpSources } from 'enums/ErpSources';
import { Functor } from 'functions/Functor';
import * as Product from 'types/Ingredient/Detail/OrderGuide/Product';
import * as ProductList from 'types/Ingredient/Detail/OrderGuide/ProductList';

export type Type = {
	id: string;
	ingredientId: string;
	products: ProductList.Type;
};

export function create(): Type {
	return {
		id: '',
		ingredientId: '',
		products: ProductList.create(),
	};
}

export async function removeProduct(obj: Type, productId: string): Promise<Type> {
	const orderGuide = {
		...obj,
		products: ProductList.removeProduct(obj.products, productId),
	};
	await updateOrderGuide(orderGuide);
	return orderGuide;
}

export async function updateOrderGuide(obj: Type): Promise<void> {
	await apiPut.callApi(obj.id, mapToApiPut(obj));
}

export async function postToApi(obj: Omit<Type, 'id'>): Promise<string> {
	return await Functor.From(obj)
		.map(mapToApiPost)
		.mapAsync((e) => apiPost.callApi(obj.ingredientId, e))
		.map((e) =>
			e.getOrDefault({
				id: '',
				ingredientId: '',
				products: [],
			})
		)
		.map((e) => e.id)
		.get();
}

function mapToApiPost(obj: Omit<Type, 'id'>): apiPost.RequestBody {
	return obj.products.map((e) => ({
		priority: e.priority ?? 0,
		productId: e.productId,
		sourceId: e.sourceId,
	}));
}

export async function postDefaultProductForIngredient(ingredientId: string): Promise<void> {
	await postToApi({
		ingredientId: ingredientId,
		products: [
			{
				...Product.create(),
				priority: 0,
				productId: ingredientId,
				sourceId: ErpSources.DEFAULT,
			},
		],
	});
}

function mapToApiPut(obj: Type): apiPut.RequestBody {
	return {
		id: obj.id,
		ingredientId: obj.ingredientId,
		products: obj.products.map((e) => ({
			priority: e.priority ?? 0,
			productId: e.productId,
			sourceId: e.sourceId,
		})),
	};
}
export function mapFromApiPostSearch(input: apiPostSearch.OrderGuide): Type {
	return {
		id: input.id,
		ingredientId: input.ingredientId,
		products: input.products.map((e) => Product.mapFromApiPost(e)),
	};
}

export function mergeWithProducts(obj: Type, products: ProductList.Type): Type {
	const output: Type = {
		...obj,
		products: [],
	};
	for (const i of obj.products) {
		const product = products.find((e) => e.productId === i.productId);
		if (!product) {
			output.products.push(i);
			continue;
		}
		output.products.push(Product.mergeWithProducts(i, product));
	}
	return output;
}
export async function changePriority(
	obj: Type,
	input: { productId: string; sourceId: string; priority: number }
): Promise<Type> {
	const orderGuide = {
		...obj,
		products: ProductList.changePriority(obj.products, input),
	};
	await updateOrderGuide(orderGuide);
	return orderGuide;
}
